<div id="dashboard-container" fxLayout="row" fxLayoutAlign="center center">
  <!-- <img id="thrive-logo" src="/assets/images/thrive-logo.webp" width="709" height="auto" /> -->
  Home page
</div>
